import React from 'react';
import ProductMediaFigure from '../../shared/ProductMediaFigure';
import HrDomainChatVisual from './HrDomainChatVisual';
import CommandHubOrbitAnimation from './CommandHubOrbitAnimation';
import {
  SemanticControlPlaneVisual,
  AccessEvaluationVisual,
  CommandHubDashboardVisual,
} from './ProductVisualPanels';

/** @deprecated Use SemanticControlPlaneVisual */
export const ContextGapMetaphorVisual = SemanticControlPlaneVisual;
export const SemanticFoundationVisual = SemanticControlPlaneVisual;

/** @deprecated Use AccessEvaluationVisual */
export const GovernedLayersVisual = AccessEvaluationVisual;
export const GovernanceRingVisual = AccessEvaluationVisual;

/** Command hub observability: orbital icon animation */
export const CommandHubVisual = CommandHubOrbitAnimation;
export const CommandHubPlaceholderVisual = CommandHubOrbitAnimation;

export { default as CommandHubOrbitAnimation } from './CommandHubOrbitAnimation';

export { SemanticControlPlaneVisual, AccessEvaluationVisual, CommandHubDashboardVisual };
export { default as GovernanceTriangleSequence } from './GovernanceTriangleSequence';
export { default as GovernanceLayerStack } from './GovernanceLayerStack';
export { default as HrDomainChatVisual } from './HrDomainChatVisual';
export { default as CoWorkChatVisual } from './CoWorkChatVisual';

export function DiscoveryPipelineVisual({ columns, flowLabel }) {
  const summary = `Mock-up of the discovery pipeline: ${flowLabel}. ${columns
    .map((col) => `${col.title}: ${col.items.join(', ')}`)
    .join('. ')}. Inventory, certify, then converse on shared context.`;
  return (
    <div
      className="relative rounded-2xl bg-gradient-to-br from-ink-900 via-slate-800 to-ink-900 p-5 ring-1 ring-white/10 shadow-xl"
      role="img"
      aria-label={summary}
    >
      <div aria-hidden="true" className="contents">
      <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-brand-300">{flowLabel}</p>
      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
        {columns.map((col, i) => (
          <div key={col.title} className="relative">
            <div className={`rounded-xl p-3 ring-1 ${col.ring} ${col.bg} min-h-[140px]`}>
              <p className={`text-[10px] font-bold uppercase tracking-wide ${col.titleClass}`}>{col.title}</p>
              <div className="mt-3 space-y-1.5">
                {col.items.map((item) => (
                  <div key={item} className="flex items-center gap-1.5 rounded-md bg-white/70 px-2 py-1 text-[10px] font-medium text-ink-700">
                    <span className="h-1 w-1 shrink-0 rounded-full bg-brand-500" />
                    {item}
                  </div>
                ))}
              </div>
            </div>
            {i < columns.length - 1 && (
              <div className="absolute -right-2 top-1/2 z-10 hidden -translate-y-1/2 text-cyan-300 sm:block" aria-hidden="true">
                →
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-4 h-px bg-gradient-to-r from-transparent via-brand-400/60 to-transparent" />
      <p className="mt-3 text-center text-[10px] font-medium text-slate-400">Inventory → certify → converse on shared context</p>
      </div>
    </div>
  );
}

/** CoWork agents: unchanged */
export function ConversationalCoWorkVisual() {
  return (
    <div className="w-full max-w-md mx-auto lg:ml-auto">
      <ProductMediaFigure id="cowork_clip2" aspect="natural" showCaption={false} />
    </div>
  );
}

export const ConversationalAgentsVisual = HrDomainChatVisual;
